import { BREAKPOINTS } from '@/constants/index';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

// TODO: Странный стор, пересекается с device, в целом не ощущается нужным, due to refactor
// Оставил для обратной совместимости
export const useWindowStore = wrapPiniaStore(
  defineStore('window', {
    state: () => ({
      window: {
        width: 0,
        height: 0,
      },
    }),

    getters: {
      windowSizes: (state) => state.window,
      windowWidth: (state) => state.window.width,
      windowHeight: (state) => state.window.height,

      isMobile: (state) => state.window.width < BREAKPOINTS.TABLET,
      isTablet: (state) =>
        state.window.width >= BREAKPOINTS.TABLET && state.window.width < BREAKPOINTS.BIG_TABLET,
      isTabletAndMore: (state) => state.window.width >= BREAKPOINTS.TABLET,
      isBigTablet: (state) =>
        state.window.width >= BREAKPOINTS.BIG_TABLET && state.window.width < BREAKPOINTS.DESKTOP,
      isBigTabletAndMore: (state) => state.window.width >= BREAKPOINTS.BIG_TABLET,
      isDesktop: (state) =>
        state.window.width >= BREAKPOINTS.DESKTOP && state.window.width < BREAKPOINTS.DESKTOP_WIDE,
      isDesktopAndMore: (state) => state.window.width >= BREAKPOINTS.DESKTOP,
      isDesktopWide: (state) => state.window.width >= BREAKPOINTS.DESKTOP_WIDE,
    },

    actions: {
      setWindowWidth(width: number) {
        this.window.width = width;
      },
      setWindowHeight(height: number) {
        this.window.height = height;
      },
    },
  }),
);
